<template>
    <div>
        <!--盘点详情-->
        <Card :bordered="false" dis-hover>
            <p slot="title">详情</p>
            <Row>
                <Col span="8"><strong>盘点人：<span class="result">{{pageData.adminName}}</span></strong></Col>
                <Col span="8"><strong>盘点时间：</strong> <span class="result">{{pageData.time}}</span></Col>
                <Col span="8"><strong>订单号：</strong> <span class="result">{{pageData.code}}</span></Col>
                <Col span="8"><strong>盘点数量：</strong> <span class="result">******</span></Col>
                <Col span="8"><strong>盈亏数量：</strong> <span class="result">******</span></Col>
                <Col span="8"><strong>盈亏金额：</strong> <span class="result">******</span></Col>
                <Col span="8"><strong>盘点前数量：</strong> <span class="result">******</span></Col>

            </Row>
        </Card>
        <div style="max-height: 600px; overflow:auto" class="overflowRightNav">
            <table slot="content" class="ive-table" v-for="(item, index) in pageData.sGoods" :key="index">
                <thead>
                <th>商品详情</th>
                <th>名称/货号</th>
                <th>规格/颜色</th>
                <th>盘点前数量</th>
                <th>盘点后数量</th>
                <th>盈亏数量</th>
                <th>盈亏金额</th>
                </thead>
                <tbody>
                <tr align="center" v-for="(k,v) in pageData.sGoods[index].sItems" >
                    <td width="200" :rowspan="v" v-if="v==0">
                        <Fy-Img
                                v-for="(m,n) in uploadList"
                                :key="n"
                                class="img"
                                :ImgSrc="m.goodsimg | filtImg"
                                :Width="120"
                                :Height="120"
                        ></Fy-Img>
                    </td>
                    <td>{{item.goodname}} / {{item.goodcode}}</td>
                    <td>{{k.size}} / {{k.color}}</td>

                    <td>{{k.nownum}}</td>
                    <td>{{k.checknum}}</td>
                    <td>{{k.quantity}}</td>
                    <td v-if="k.money>=0" style="color: #ff9763">{{k.money}}</td>
                    <td v-else style="color: #62ac77">{{k.money}}</td>
                </tr>

                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pageData:{}
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getSetpoint(this.$route.query.id)

        },

        methods: {
            //获取采购单
            getSetpoint(id){
                this.$Api.getSetpoint({
                    id:id
                }).then(res => {
                    if(res.code==200){
                        this.pageData = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>